module.exports = __webpack_public_path__ + "img/nurul.2b821665.png";